// src/config/api.ts

interface ApiConfig {
    baseUrl: string;
    endpoints: {
        upload: string;
        report: string;
        uploadXlsx: string;
        pdfReport: string;
        catalogBase: string;
    };
}

const apiConfig: ApiConfig = {
    baseUrl: process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000",
    endpoints: {
        upload: process.env.NEXT_PUBLIC_UPLOAD_ENDPOINT || "/uploadfile",
        report: process.env.NEXT_PUBLIC_REPORT_ENDPOINT || "/generatereport",
        uploadXlsx:
            process.env.NEXT_PUBLIC_XLSX_ENDPOINT || "/files/upload_assessment",
        pdfReport:
            process.env.NEXT_PUBLIC_PDF_REPORT_ENDPOINT ||
            "/generate_assessment_summary_risks_proposal",
        catalogBase: process.env.NEXT_PUBLIC_CATALOG_BASE_ENDPOINT || "/catalog",
    },
};

export default apiConfig;